export default class DateUtils {
  static convertYMDToDate(year, month, day) {
    const BASE_10_RADIX = 10;

    return new Date(
      parseInt(year, BASE_10_RADIX),
      parseInt(month, BASE_10_RADIX) - 1, // Month is zero indexed but the others aren't.
      parseInt(day, BASE_10_RADIX),
      0,
      0,
      0,
      0,
    );
  }

  static calculateAgeInYears(birthDate) {
    const currentDate = new Date();
    let age = currentDate.getFullYear() - birthDate.getFullYear();
    const monthDifference = currentDate.getMonth() - birthDate.getMonth();

    // If the birth month hasn't occurred yet this year, or if it's the birth month but the birth day hasn't occurred yet, subtract 1 from the age.
    if (monthDifference < 0 || (monthDifference === 0 && currentDate.getDate() < birthDate.getDate())) {
      age = age - 1;
    }

    return age;
  }
}
